import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useState } from 'react';
import MediaQuery from 'react-responsive';
import { FaChevronRight } from "react-icons/fa";
import { Navbar, Nav, NavDropdown, Container } from 'react-bootstrap'; // JSS
// import { Link } from '@sitecore-jss/sitecore-jss-react';

import { SitecoreLink } from '../link/Link'; //ga tracker

import gaTracker from '../../util/ga-analytics/gaTracker';

var MenuList = function MenuList(_ref) {
  var item = _ref.item,
      shopLayout = _ref.shopLayout;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      active = _useState2[0],
      setActive = _useState2[1];

  if (typeof item.navigationTitle !== 'undefined') {
    var _item$children, _item$children3, _item$children4, _item$children5, _item$children7;

    var model = {
      //value: item.navigationTitle.value,
      value: {
        href: item.url,
        title: item.navigationTitle.value,
        text: item.navigationTitle.value
      }
    };

    var itemClick = function itemClick(e) {
      e.stopPropagation();
      var data = {
        gtm: {
          uniqueEventId: '5',
          elementUrl: item.url,
          elementId: "secondaryListItem-".concat(item.url)
        },
        event: 'gtm.click'
      };
      gaTracker(data);
      return false;
    };

    var tertiaryMenuClick = function tertiaryMenuClick(e) {
      e.stopPropagation();
      var elementClassList = document.getElementById("secondaryListItem-".concat(item.url)).classList;

      if (elementClassList.contains('secondaryLink')) {
        if (elementClassList.contains('is-active') || elementClassList.contains('noChildren')) {
          var data = {
            gtm: {
              uniqueEventId: '5',
              elementUrl: item.url,
              elementId: "secondaryListItem-".concat(item.url)
            },
            event: 'gtm.click'
          };
          gaTracker(data);
          return false;
        } else {
          e.preventDefault();
          setActive(!active);
        }
      } else {
        var _data = {
          gtm: {
            uniqueEventId: '5',
            elementUrl: item.url,
            elementId: "secondaryListItem-".concat(item.url)
          },
          event: 'gtm.click'
        };
        gaTracker(_data);
        return false;
      }
    };

    var handleOpen = function handleOpen(e) {
      e.stopPropagation();
      e.preventDefault();
      setActive(!active);
    };

    return /*#__PURE__*/React.createElement(React.Fragment, null, shopLayout ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(MediaQuery, {
      minWidth: 991
    }, /*#__PURE__*/React.createElement("div", {
      className: "cb-menu__secondary-list-item"
    }, /*#__PURE__*/React.createElement(SitecoreLink, {
      field: model,
      onClick: tertiaryMenuClick,
      id: "secondaryListItem-".concat(item.url)
    }), ((_item$children = item.children) === null || _item$children === void 0 ? void 0 : _item$children.length) ? item.children.map(function (item, index) {
      var _item$children2;

      var model = {
        navigationTitle: item.navigationTitle.value,
        href: item.url,
        title: item.navigationTitle.value,
        text: item.navigationTitle.value,
        chidlren: item.children
      };
      return /*#__PURE__*/React.createElement(React.Fragment, {
        key: index
      }, /*#__PURE__*/React.createElement(Nav, {
        as: "ul"
      }, /*#__PURE__*/React.createElement("li", {
        key: 'li' + index
      }, /*#__PURE__*/React.createElement(SitecoreLink, {
        key: 'link' + index,
        field: model,
        onClick: itemClick
      }), ((_item$children2 = item.children) === null || _item$children2 === void 0 ? void 0 : _item$children2.length) ? item.children.map(function (item, index) {
        return /*#__PURE__*/React.createElement(MenuList, {
          item: item,
          key: index
        });
      }) : '')));
    }) : null)), /*#__PURE__*/React.createElement(MediaQuery, {
      maxWidth: 990
    }, /*#__PURE__*/React.createElement("div", {
      className: "cb-menu__secondary-list-item"
    }, /*#__PURE__*/React.createElement("div", {
      className: "position-relative"
    }, /*#__PURE__*/React.createElement(SitecoreLink, {
      field: model,
      className: "".concat(active ? "is-active secondaryLink" : "secondaryLink", " ").concat(((_item$children3 = item.children) === null || _item$children3 === void 0 ? void 0 : _item$children3.length) > 0 ? '' : 'noChildren'),
      onClick: tertiaryMenuClick,
      id: "secondaryListItem-".concat(item.url)
    }), ((_item$children4 = item.children) === null || _item$children4 === void 0 ? void 0 : _item$children4.length) > 0 && /*#__PURE__*/React.createElement("span", {
      onClick: function onClick(e) {
        return handleOpen(e);
      },
      className: "cb-menu__main-link__mobile-chevron"
    }, /*#__PURE__*/React.createElement(FaChevronRight, {
      className: active ? 'is-active chevronRight' : 'chevronRight'
    }))), active && ((_item$children5 = item.children) === null || _item$children5 === void 0 ? void 0 : _item$children5.length) ? item.children.map(function (item, index) {
      var _item$children6;

      var model = {
        navigationTitle: item.navigationTitle.value,
        href: item.url,
        title: item.navigationTitle.value,
        text: item.navigationTitle.value,
        chidlren: item.children
      };
      return /*#__PURE__*/React.createElement(React.Fragment, {
        key: index
      }, /*#__PURE__*/React.createElement(Nav, {
        as: "ul"
      }, /*#__PURE__*/React.createElement("li", {
        key: 'li' + index
      }, /*#__PURE__*/React.createElement(SitecoreLink, {
        key: 'link' + index,
        field: model,
        onClick: itemClick
      }), ((_item$children6 = item.children) === null || _item$children6 === void 0 ? void 0 : _item$children6.length) ? item.children.map(function (item, index) {
        return /*#__PURE__*/React.createElement(MenuList, {
          item: item,
          key: index
        });
      }) : '')));
    }) : null))) : /*#__PURE__*/React.createElement("div", {
      className: "cb-menu__secondary-list-item"
    }, /*#__PURE__*/React.createElement(SitecoreLink, {
      field: model,
      onClick: tertiaryMenuClick,
      id: "secondaryListItem-".concat(item.url)
    }), ((_item$children7 = item.children) === null || _item$children7 === void 0 ? void 0 : _item$children7.length) ? item.children.map(function (item, index) {
      var _item$children8;

      var model = {
        navigationTitle: item.navigationTitle.value,
        href: item.url,
        title: item.navigationTitle.value,
        text: item.navigationTitle.value,
        chidlren: item.children
      };
      return /*#__PURE__*/React.createElement(React.Fragment, {
        key: index
      }, /*#__PURE__*/React.createElement(Nav, {
        as: "ul"
      }, /*#__PURE__*/React.createElement("li", {
        key: 'li' + index
      }, /*#__PURE__*/React.createElement(SitecoreLink, {
        key: 'link' + index,
        field: model,
        onClick: itemClick
      }), ((_item$children8 = item.children) === null || _item$children8 === void 0 ? void 0 : _item$children8.length) ? item.children.map(function (item, index) {
        return /*#__PURE__*/React.createElement(MenuList, {
          item: item,
          key: index
        });
      }) : '')));
    }) : null));
  } else {
    return null;
  }
};

export default MenuList;